import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { initI18n } from './lib/i18n'
import { trackViewportInsets } from './pwa/viewportInsets'
import { lockViewport } from './pwa/viewportLock'
import './styles/global.css'

/**
 * Startup order: lock the viewport before anything paints, await i18n (no
 * flash of raw keys), then render. Data loads inside App behind a splash.
 */
async function bootstrap() {
  lockViewport()
  trackViewportInsets()
  // Ask the browser not to evict the offline copy (Chromium/Firefox honour it;
  // iOS protects installed Home Screen apps instead).
  void navigator.storage?.persist?.().catch(() => false)
  await initI18n('vi')

  const rootEl = document.getElementById('root')
  if (!rootEl) throw new Error('#root missing')
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void bootstrap()
